import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import NotesArea from './notesarea';
import { GlobalHotKeys } from '../../../../node_modules/react-hotkeys';

const useStyles = makeStyles(theme => ({
  notesContainer: {
    padding: '0.5em'
  },
  toggleButtonsContainer: {
    padding: '0.2em 0.2em',
    '& button': {
      float: 'right',
      marginLeft: '0.4em'
    },
    '& span': {
      marginLeft:'4px',
      fontSize:'16px'
    }
  }
}));

const EncounterCard = ({
  forwardRef,
  noteMarkup,
  dateOfService,
  isPoppedOut = false
}) => {
  const classes = useStyles();

  const notesProps = isPoppedOut ? { containerHeight: '90%' } : {};

  const keyMap = {
    TOGGLE_HIGHLIGHTS: ["h", "H"],
    TOGGLE_EXCLUSIONS: ["e", "E"],
    SHIFT_ENC_TEXT_UP: ["Shift+ArrowUp"],
    SHIFT_ENC_TEXT_DOWN: ["Shift+ArrowDown"]
  }

  const keyHandlers = {
    TOGGLE_HIGHLIGHTS: event => {
      event.preventDefault();
      $('#highlightToggle').click();
    },
    TOGGLE_EXCLUSIONS: event => {
      event.preventDefault();
      $('#exclusionToggle').click();
    },
    SHIFT_ENC_TEXT_UP: event => {
      event.preventDefault();
      $('#encounter-text-area').scrollTop(-250 + $('#encounter-text-area').scrollTop());
    },
    SHIFT_ENC_TEXT_DOWN: event => {
      event.preventDefault();
      $('#encounter-text-area').scrollTop(250 + $('#encounter-text-area').scrollTop());
    }
  }

  return (
    <GlobalHotKeys keyMap={keyMap} handlers={keyHandlers} allowChanges={true}>
      <div>
        <div className={classes.toggleButtonsContainer}>
          <span><strong>{dateOfService}</strong></span>
          <button id="exclusionToggle">Exclusions</button>
          <button id="highlightToggle">Highlights</button>
        </div>
        <div ref={forwardRef} className={classes.notesContainer}>
          <NotesArea noteMarkup={noteMarkup} {...notesProps} />
        </div>
      </div>
    </GlobalHotKeys>
  );
};

EncounterCard.propTypes = {
  noteMarkup: PropTypes.string.isRequired,
  dateOfService: PropTypes.string.isRequired,
  isPoppedOut: PropTypes.bool.isRequired
};

export default EncounterCard;
